import React, { useState, useContext } from 'react';
import './NewsfeedItem.css';
import axiosConfig from '../../../../utils/axiosConfig';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Box, Button, Card, CardActions, CardActionArea, CardHeader, CardContent, Divider, Grid, IconButton, Menu, MenuItem, Paper, TextField, Typography } from '@material-ui/core';

import PeopleAltTwoToneIcon from '@material-ui/icons/PeopleAltTwoTone';
import { MoreVert as MoreVertIcon } from '@material-ui/icons';
import PostCommentForm from './PostCommentForm/PostCommentForm';
import CommentItem from './CommentItem/CommentItem';
import NewsfeedModalForm from './NewsfeedModalForm/NewsfeedModalForm';

import { StateContext, DispatchContext } from '../../../../context/Provider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';

import { ImageList, ImageListItem } from '@material-ui/core'

const ClassCommentsCount = (props) => {
    return (
        <>
            <Button
                startIcon={<PeopleAltTwoToneIcon />}
                style={{textTransform: 'none', color: 'rgba(0, 0, 0, 0.54)'}}
                onClick={() => console.log('show/hide comments')}
            >
                {`${props.totalComments} class comment/s`}
            </Button>
        </>
    );
}

const NewsfeedItem = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { authState } = appState;
    const { globalDispatch } = appDispatch;

    const useStyles = makeStyles((theme) => ({
        root: {
            // minWidth: 345
        },
        cardHeader: {
            // paddingBottom: '35px',
            // backgroundColor: props.themeColor ? props.themeColor : "#ff5722",
            // color: '#fff'
        },
        cartTitle: {
            fontWeight: 500,
            marginBottom: 0
        },
        subHeader: {
            // color: '#fff'
        },
        moreVertIcon: {
            // color: '#fff'
        },
        small: {
            width: theme.spacing(3),
            height: theme.spacing(3),
        },
        medium: {
            width: theme.spacing(4),
            height: theme.spacing(4),
        },
        root1: {
            padding: '2px 4px',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
        },
        input1: {
            borderRadius: '12px',
            paddingTop: '3px',
            paddingBottom: '3px',
            paddingLeft: '15px',
            background: "rgb(0, 0, 0, 0.05)",
            border: '2px',
            marginLeft: theme.spacing(1),
            flex: 1
        },
        iconButton1: {
            padding: 10,
            "&:hover": {
                backgroundColor: "#fff"
            }
        },
        divider1: {
            height: 28,
            margin: 4,
        }
    }));

    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [showComments, setShowComments] = useState(true);
    const openDropdown = Boolean(anchorEl);
    const [newsfeedModalOpen, setNewsfeedModalOpen] = useState(false);

    const handleMenu = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleNewsfeedModalOpen = () => {
        setNewsfeedModalOpen(true);
    }

    const handleNewsfeedModalClose = () => {
        setNewsfeedModalOpen(false);
    }

    const toggleCommentsVisibility = () => {
        setShowComments(!showComments);
    }

    async function removeAnnouncement(announcementID) {

        globalDispatch({type: 'setIsLoading', value: true});

        try {
            const response = await axiosConfig.post(`/announcements/${announcementID}`, {
                _method: "DELETE"
            });

            const { status_code, message } = response.data;

            if (status_code == 'ok') {
                props.fetchAnnouncements();
            }

        } catch (e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    async function setPinnedPost(announcementID) {
        globalDispatch({type: 'setIsLoading', value: true});

        try {
            const response = await axiosConfig.post(`/pinnedPosts/${announcementID}`, {
                _method: "DELETE"
            });

            const { status_code, message } = response.data;

            if (status_code == 'ok') {
                props.fetchAnnouncements();
            }

        } catch (e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    const shortenFilename = (filename) => {
        let filenameLength = filename.length
        if (filenameLength > 30) {
            return `${filename.substr(0, 15)}...${filename.substr(filenameLength - 15)}`
        }

        return filename
    }

    return (
        <>
            <Grid item xs={12} sm={12} md={10} lg={8} xl={8}>
                <Card>
                    <CardHeader
                        className={classes.cardHeader}
                        avatar={<Avatar aria-label="recipe" src={props.announcement.avatar}>D</Avatar>}
                        action={
                            authState.user.id === props.announcement.posted_by && (
                                <IconButton
                                    aria-label="settings"
                                    onTouchStart={(event) => event.stopPropagation()}
                                    onMouseDown={(event) => event.stopPropagation()}
                                    onClick={handleMenu}
                                >
                                    <MoreVertIcon className={classes.moreVertIcon} />
                                </IconButton>
                            )
                        }
                        title={
                            <Typography className={classes.cartTitle} gutterBottom variant="body1" component="h2">
                                { props.announcement.author }
                            </Typography>
                        }
                        subheader={
                            <Typography className={classes.subHeader} variant="body2" color="textSecondary" component="p">
                                { props.announcement.formatted_created_at }
                            </Typography>
                        }
                    />

                    <Menu
                        id="menu-cardheader"
                        anchorEl={anchorEl}
                        getContentAnchorEl={null} // this will display the popover below the icon
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left"
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "center"
                        }}
                        open={openDropdown}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={() => { handleClose(); handleNewsfeedModalOpen(); }}>
                            Edit Announcement
                        </MenuItem>
                        <MenuItem onClick={() => { handleClose(); setPinnedPost(props.announcement.id); }}>
                            { props.announcement.is_pinned ? 'Unpin' : 'Pin' } Post
                        </MenuItem>
                        <MenuItem onClick={() => {
                            if (window.confirm(`Are you sure you want to remove this announcement?`)) {
                                handleClose();
                                removeAnnouncement(props.announcement.id);
                            }
                        }}>Delete</MenuItem>
                    </Menu>

                    <Box px={2} mx={0} pb={3}>
                        <Box dangerouslySetInnerHTML={{__html: props.announcement.description}} />

                        {props.announcement.attachments?.length > 0 && <Box>
                            <div>
                                <ImageList rowHeight={160} cols={3}>
                                    {props.announcement.attachments.map((attachment) => {
                                        if (attachment.file_type === 'image') {
                                            return (
                                                <ImageListItem key={attachment.id} cols={1}>
                                                    <img src={attachment.attachment_url} alt={attachment.filename} />
                                                </ImageListItem>
                                            )
                                        }
                                    })}
                                </ImageList>
                            </div>
                        </Box>}

                        {props.announcement.attachments?.length > 0 && <Box>
                            <Box id="attachment-container">
                                {props.announcement.attachments.map((attachment) => {
                                    if (attachment.file_type !== 'image') {
                                        return (
                                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                            <a href="#" className="file-attachment">
                                                <FontAwesomeIcon icon={faFile}/> {shortenFilename(attachment.filename)}
                                            </a>
                                        )
                                    }

                                    return (<></>);
                                })}
                            </Box>
                        </Box>}
                    </Box>

                    { props.announcement.totalComments > 0 && <Divider />}

                    { props.announcement.totalComments > 0 && <CardContent style={{minHeight: '5px'}}>
                        { props.announcement.totalComments > 0 ? (
                            <Button
                                startIcon={<PeopleAltTwoToneIcon />}
                                style={{textTransform: 'none', color: 'rgba(0, 0, 0, 0.54)'}}
                                onClick={toggleCommentsVisibility}
                            >
                                {`${props.announcement.totalComments} class comment/s`}
                            </Button>
                        ) : null }

                        <Box style={{display: showComments ? 'block' : 'none' }}>
                            {props.announcement.comments.map((comment, i) => (
                                <CommentItem
                                    key={comment.id}
                                    classes={classes}
                                    comment={comment}
                                    fetchAnnouncements={props.fetchAnnouncements}
                                />
                            ))}
                        </Box>
                    </CardContent> }

                    <Divider />

                    <PostCommentForm
                        announcementID={props.announcement.id}
                        classes={classes}
                        fetchAnnouncements={props.fetchAnnouncements}
                    />

                    { newsfeedModalOpen ? (
                        <NewsfeedModalForm
                            open={newsfeedModalOpen}
                            handleClose={handleNewsfeedModalClose}
                            dialogTitle={`Edit Announcement`}
                            announcementID={props.announcement.id}
                            description={props.announcement.description}
                            fetchAnnouncements={props.fetchAnnouncements}
                        />
                        ) : null
                    }

                </Card>
            </Grid>
        </>
    );
}

export default NewsfeedItem;